<template>
  <BaseDeviceWallpaperCard
    v-bind="cardProps"
    @toggle-selection="emit('toggle-selection', $event)"
    @view="emit('view', $event)"
    @download="emit('download', $event)"
    @favorite="emit('favorite', $event)"
    @edit="emit('edit', $event)"
    @delete="emit('delete', $event)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseDeviceWallpaperCard from './BaseDeviceWallpaperCard.vue'
import type { Wallpaper } from '../../firebase/schema'
import type { DeviceWallpaperTab } from '../../composables/useDeviceWallpaperTabs'

interface Props {
  wallpaper: Wallpaper
  categoryMap: Record<string, string>
  showAdminActions?: boolean
  isSelected?: boolean
}

const emit = defineEmits<{
  (e: 'toggle-selection', id: string): void
  (e: 'view', wallpaper: Wallpaper): void
  (e: 'download', wallpaper: Wallpaper): void
  (e: 'favorite', wallpaper: Wallpaper): void
  (e: 'edit', wallpaper: Wallpaper): void
  (e: 'delete', wallpaper: Wallpaper): void
}>()

const props = withDefaults(defineProps<Props>(), {
  showAdminActions: false,
  isSelected: false
})

const cardProps = computed(() => ({
  wallpaper: props.wallpaper,
  categoryMap: props.categoryMap,
  showAdminActions: props.showAdminActions,
  isSelected: props.isSelected,
  device: 'laptop' as DeviceWallpaperTab,
  deviceLabel: 'Laptop',
  deviceShortLabel: 'Laptop',
  deviceEmoji: '💻',
  subtitle: '',
  aspectRatioClass: 'aspect-[16/10]',
  aspectRatioLabel: '16:10',
  targetAspect: 16 / 10,
  targetWidth: 1440,
  targetHeight: 900,
  badgeClass: 'bg-gradient-to-r from-emerald-500 to-teal-500'
}))
</script>
